module.exports = __webpack_public_path__ + "img/artwork-error-bg.ab54300c.png";